export const removeLastSlash = (url: string) => {
    const lastIndex = url.length - 1;
    if (url[lastIndex] === "/") {
        url = url.substr(lastIndex);
    }
    return url;
}
